import React, { Component } from 'react';
import { getMembers, deleteMembers, postMembers } from '../../common/fetch';
import Wrapper, { ModalWrapper } from './style';
import { Table, Button, Modal, Input, message } from 'antd';
import { RUNNING_MESSAGE } from '../../config/constants';
import { validEmail } from '../../common/utils';

const { Column } = Table;

class ExchangeMember extends Component {
	state = {
		loading: true,
		id: 0,
		member: [],
		pagination: { current: 1, total: 0 },
		isOpen: false,
		step: 0,
		email: '',
		errMsg: '',
	};

	componentDidMount() {
		const { exchange, history, location } = this.props;
		if (exchange.length === 0) {
			history.push('/');
		}
		if (location.search === '') {
			this.getData(exchange[0].id);
			this.setState({ id: exchange[0].id });
		} else {
			const id = location.search.split('=')[1];
			this.getData(id);
			this.setState({ id });
		}
	}

	getData = async (id, page = 1) => {
		try {
			const res = await getMembers(id, page);
			this.setState({
				loading: false,
				member: res.data.data
					.filter((item) => item.role !== 'admin')
					.map((item) => {
						const User = { ...item, email: item.User.email };
						delete User.User;
						return User;
					}),
				pagination: { ...this.state.pagination, total: res.data.count },
			});
		} catch (error) {
			console.error(error);
			this.setState({
				loading: false,
			});
		}
	};

	deleteData = (id) => {
		Modal.confirm({
			title: 'Do you want to remove the member?',
			onOk: async () => {
				try {
					await deleteMembers(this.state.id, id);
					message.success('Success to remove the member');
					this.setState({
						member: this.state.member.filter(
							(item) => parseInt(item.user_id) !== parseInt(id)
						),
					});
				} catch (error) {
					console.error(error);
					message.success('Failed to remove the member');
				}
			},
		});
	};

	postData = async () => {
		try {
			const body = {
				email: this.state.email,
			};
			await postMembers(this.state.id, body);
			this.setState(
				{
					step: 2,
				},
				() => this.getData(this.state.id)
			);
		} catch (error) {
			message.success('Fail to send a mail');
			this.setState({
				isOpen: false,
				step: 0,
				email: '',
			});
		}
	};

	handleTableChange = (pagination, filters, sorter) => {
		const pager = { ...this.state.pagination };
		pager.current = pagination.current;
		this.setState(
			{
				pagination: pager,
			},
			() => {
				this.getData(this.state.id, pagination.current);
			}
		);
	};

	openModal = () => {
		this.setState({ isOpen: true });
	};

	closeModal = () => {
		this.setState({
			isOpen: false,
			step: 0,
			email: '',
		});
	};

	handleChange = (e) => {
		const { name, value } = e.target;
		this.setState({ [name]: value });
	};

	confirmEmail = () => {
		if (this.state.email === '') {
			return;
		}
		if (validEmail(this.state.email)) {
			let isOkay = true;
			this.state.member.forEach((item) => {
				if (item.email === this.state.email) {
					isOkay = false;
				}
			});
			if (!isOkay) {
				this.setState({
					step: 2,
				});
				return;
			}
			this.setState({ step: 1 });
		} else {
			message.error('You should input an email.');
		}
	};

	render() {
		const { member, isOpen, pagination, loading, email, step } = this.state;
		const { exchange, location } = this.props;
		let exchangeName = '';
		let is_running = false;
		if (location.search === '') {
			exchangeName = exchange[0].name;
			is_running = exchange[0].is_running;
		} else {
			const id = location.search.split('=')[1];
			exchangeName = exchange.filter((item) => item.id === parseInt(id))[0]
				.name;
			is_running = exchange.filter((item) => item.id === parseInt(id))[0]
				.is_running;
		}
		return (
			<Wrapper>
				<div className="main-panel">
					<h2>Members of {exchangeName}</h2>
					<p style={{ maxWidth: 340 }}>
						Add a member to help setup your exchange. Members will be
						given certain amount of access to your exchange setup for the
						purpose server setup.
					</p>
					<Button
						type="primary"
						onClick={() => {
							if (is_running) {
								message.info(RUNNING_MESSAGE);
								return;
							} else {
								this.openModal();
							}
						}}
					>
						Invite Member
					</Button>
				</div>
				<div className="member">
					<Table
						dataSource={member}
						rowKey={(data) => {
							return data.id;
						}}
						loading={loading}
						pagination={pagination}
						// onChange={handleTableChange}
					>
						<Column title="Member Email" dataIndex="email" width="20%" />
						<Column title="Role" dataIndex="role" width="60%" />
						<Column
							title="Remove"
							dataIndex="user_id"
							width="60%"
							render={(id) => (
								<span
									className="btn-delete"
									onClick={() => {
										this.deleteData(id);
									}}
								>
									Remove
								</span>
							)}
						/>
					</Table>
					<Modal
						visible={isOpen}
						title={null}
						footer={null}
						onCancel={this.closeModal}
					>
						{step === 0 ? (
							<ModalWrapper>
								<h3>Members Email</h3>
								<p>
									This member will be given certain privileges for the
									purpose of your exchange server setup
								</p>
								<Input
									name="email"
									value={email}
									onChange={this.handleChange}
									placeholder="Email Address"
								/>
								<div className="btn-area">
									<Button block onClick={this.closeModal}>
										Back
									</Button>
									<Button
										block
										type="primary"
										onClick={this.confirmEmail}
									>
										Next
									</Button>
								</div>
							</ModalWrapper>
						) : step === 1 ? (
							<ModalWrapper>
								<h3>Are you sure you want to invite this member?</h3>
								<p className="confirm-mail">{email}</p>
								<div className="btn-area">
									<Button
										block
										onClick={() => {
											this.setState({ step: 0 });
										}}
									>
										Back
									</Button>
									<Button block type="primary" onClick={this.postData}>
										Invite Member
									</Button>
								</div>
							</ModalWrapper>
						) : (
							<ModalWrapper className="already-sent">
								<h3>Invite Sent!</h3>
								<p className="confirm-mail">
									An email has been sent to '{email}' <br />
									with instruction for your exchange setup"
								</p>
								<div className="btn-area">
									<Button
										block
										type="primary"
										onClick={this.closeModal}
									>
										Okay
									</Button>
								</div>
							</ModalWrapper>
						)}
					</Modal>
				</div>
			</Wrapper>
		);
	}
}

export default ExchangeMember;
